import {PhoneHQSortHeader, PhoneHQLoader, PhoneHQSwitch, PhoneHQGlyph, PhoneHQButton} from 'ch3-ui-lib';
import {
    ApiKeySummary,
    IntegrationStatusEnum,
    useGetApiKeysQuery, useUpdateApiKeyMutation
} from "../../../store/features/integrations/integrationsService";
import {RootState, useAppDispatch} from "../../../store/store.ts";
import {useSelector} from "react-redux";
import AdminPanelRestrictedView from "../../../components/AdminPanelRestrictedView/AdminPanelRestrictedView.tsx";
import {useState} from "react";
import {showToast} from "../../../store/features/Notifications/notificationsSlice.tsx";

import {ApiKeyCreationDialog} from "./ApiKeyCreationDialog.tsx";
import DeleteApiKeyModal from "./DeleteApiKey.tsx";
import EditApiKeyModal from "./EditApiKey.tsx";
import {Link} from "react-router-dom";

const ApiList = () => {
    const dispatch = useAppDispatch();
    const [updateApiKey] = useUpdateApiKeyMutation();
    const {data: apiKeys, isLoading} = useGetApiKeysQuery();
    const [createDialogOpen, setCreateDialogOpen] = useState(false);

    const toggleApiKey = async (apiKey: ApiKeySummary) => {
        try {
            await updateApiKey({
                data: {id: apiKey.id, name: apiKey.name, status: apiKey.status === IntegrationStatusEnum.ENABLED ? IntegrationStatusEnum.DISABLED : IntegrationStatusEnum.ENABLED},
                id: Number(apiKey.id)
                
            }).unwrap();

            
            dispatch(showToast({description: 'Api Key updated successfully', type: 'success'}));
        } catch (e) {
            dispatch(showToast({description: 'Api Key update failed', type: 'error'}));
        }
    }

    const role = useSelector((state: RootState) => state.auth.role);
    const isAdminPath = location.pathname.includes('admin');
    return (
        <>

            {Boolean(role == 'USER') && isAdminPath &&
                <AdminPanelRestrictedView></AdminPanelRestrictedView>
            }

            {
                isLoading && (
                    <div className="flex justify-center items-center h-screen">
                        <PhoneHQLoader/>
                    </div>
                )
            }
            {(!isLoading) && <div className="w-full">

                <div className={`flex justify-between items-center  `}>


                    <div className=' w-full'>
                        <div className="flex flex-row  border-line border-b ">
                            <div className='border-r border-line max-w-[344px] py-6'>
                                <div className='font-semibold px-8 text-md'>
                                    API key
                                </div>
                                <div className='text-ink-muted px-8 pb-5 text-sm'>
                                    Thanks to the API, you will be able to connect PhoneHQ with hundreds of apps!
                                </div>
                                <Link target='_blank' to={(window.__ENV__.URL_WEBAPP_API_PUBLIC || window.__ENV__.URL_WEBAPP_API).replace(/\/$/, '') + '/swagger-ui/#/'}>
                                <div className="flex px-8">
                                    
                                    <span className='text-brand-ink font-semibold'>Learn more</span>
                                    <PhoneHQGlyph name='open_in_new' size={14} className="text-brand-ink font-semibold"/>
                                </div>
                                </Link>
                            </div>

                            <div className=' flex w-full  flex-col'>
                                <div className="flex justify-between items-center p-6 border-b border-line">
                                    <div className='font-semibold text-md'>
                                        Create new API key
                                    </div>
                                    <PhoneHQButton
                                        phq-id="apiList-addApiKeyTriggerBtn"
                                        variant="primary"
                                        size="sm"
                                        onClick={() => setCreateDialogOpen(true)}
                                    >
                                        Create new
                                    </PhoneHQButton>
                                </ div>
                                <div className={'overflow-y-auto max-h-[calc(100vh-90px-var(--header-height))]'}>
                                    <table
                                        className="w-full overflow-y-auto max-h-[calc(100vh-200px-var(--header-height))]">


                                        {Boolean(apiKeys?.data.length) && <thead className="border-t border-line">
                                        <tr>
                                            <th className="px-4 py-3 ">
                                                <PhoneHQSortHeader label={'User API keys'}/>
                                            </th>
                                            <th className="px-4 py-3 ">
                                                <PhoneHQSortHeader label={''}/>
                                            </th>
                                            <th className="px-4 py-3">
                                                <PhoneHQSortHeader label={'Active'}/>
                                            </th>


                                        </tr>
                                        </thead>
                                        }                           
                                        <tbody>
                                        {apiKeys?.data.map((apiKey) => (
                                        <tr
                                        key={apiKey.id}
                                        className="border-t border-line"
                                    >

                                        <td className="px-4 py-6">
                                            <div className="flex items-center">
                                                <PhoneHQGlyph name='key' size={16} className="text-ink font-semibold"/>

                                                <div className="text-sm">{apiKey.name}</div>
                                            </div>

                                        </td>
                                        <td className="px-4 py-6 w-[100px] ml-auto">
                                            <div className="flex items-center">
                                                
                                                <div>...</div>
                                                <div className="text-sm">{apiKey.apiKeyShortcut}</div>
                                            </div>

                                        </td>

                                        <td className="px-4 py-6 ">
                                            <PhoneHQSwitch checked={apiKey.status === IntegrationStatusEnum.ENABLED}
                                                    switchFirst
                                                    onCheckedChange={() => toggleApiKey(apiKey)}/>
                                        </td>
                                        <td className="px-7 py-6 !w-[170px]">
                                            <div className="flex gap-9 justify-end ">
                                            
                                        <div className="text-md text-danger-ink font-semibold"><EditApiKeyModal
                                                id={apiKey.id} ></EditApiKeyModal></div>
                                                <div className="text-md text-danger-ink font-semibold"><DeleteApiKeyModal
                                                id={apiKey.id}></DeleteApiKeyModal></div>
                                            </div>
                                        </td>

                                    </tr>
                                        )
                                        )}
                                        


                                        </tbody>


                                    </table>
                                </div>
                            </div>
                            
                        </div>
                    </div>


                </div>

            </div>}
            <ApiKeyCreationDialog open={createDialogOpen} onOpenChange={setCreateDialogOpen}/>
        </>
    );
}
export default ApiList;
